module.exports = __webpack_public_path__ + "static/media/m_beard_stiletto_long__square.4bc47149.png";